export default __webpack_public_path__ + "static/media/kenlo.9b0558cb.svg";